import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu společnosti.
 */
class SpolecnostForm extends Component<WithTranslation> {

    static formName = 'SpolecnostForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('partner_code')} name="kodPartner" disabled={submitting} required/>
                <ff.String label={t('labels.name')} name="nazevSpolecnost" disabled={submitting} required/>
                <ff.String label={t('cin')} name="ic" disabled={submitting}/>
                <ff.String label={t('vatin')} name="dic" disabled={submitting}/>
                <ff.String label={t('email')} name="email" disabled={submitting}/>
                <ff.String label={t('phone')} name="telefon" disabled={submitting}/>
                {/*<CustomCheckboxField label="Povinný název objednávky " name="povinneNaklStredisko" disabled={submitting}/>*/}
                {/*<CustomCheckboxField label="Název objednávky volným text " name="naklStrediskoTextem" disabled={submitting}/>*/}
                <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting}/>
                <CustomCheckboxField label={t('cash_only')} name="pouzeHotovost" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: SpolecnostForm.formName,
    validate: (data) => utils.requireFields(["kodPartner", "nazevSpolecnost"])(data),
})(SpolecnostForm)));
